import React from 'react';
import { Box, type Theme, Typography, useMediaQuery } from '@mui/material';
import { useI18nContext } from '@procore/core-react';
import ExpandableText from '../Layout/ExpandableText';
import { useStyles } from './PublicProjectInstructions.styles';

const PublicProjectInstructions = ({
  projectBiddingInstruction,
}: {
  projectBiddingInstruction: string;
}) => {
  const I18n = useI18nContext();
  const classes = useStyles();
  const inMobileMode = useMediaQuery(
    (theme: Theme) => theme.breakpoints.down(600),
    { noSsr: true }
  );

  if (!projectBiddingInstruction) {
    return null;
  }

  return (
    <Box
      data-test-id="public-project-instructions-contents"
      style={{ paddingBottom: '17px' }}
    >
      <Typography variant="h2" className={classes.title}>
        {I18n.t(
          'pages.j.public_project_layout.public_project_instructions.bidding_instructions'
        )}
      </Typography>
      <ExpandableText
        text={projectBiddingInstruction}
        textClassName={classes.instructions}
        expandTextClassName={classes.showMoreOrLessText}
        textCutoffLength={inMobileMode ? 220 : 800}
      />
    </Box>
  );
};

export default PublicProjectInstructions;
